import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";

const features = [
  {
    icon: "ri-archive-drawer-line",
    title: "系统化角色盘点",
    desc: "每位女主都有完整的人设档案：身份、萌娘属性、性格与CP关系一站整理。",
  },
  {
    icon: "ri-search-eye-line",
    title: "按需快速定位",
    desc: "支持按身份、萌娘属性、作品筛选，输入名字即可直达想看的角色页面。",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "读者热度参考",
    desc: "人气分与CP热度来自站内讨论，帮你快速判断某位女主是否合口味。",
  },
  {
    icon: "ri-refresh-line",
    title: "随连载持续更新",
    desc: "连载中的作品会随剧情补充角色资料，人物关系线不断更新完善。",
  },
];

export default function WhyUs() {
  return (
    <section className="bg-foreground-950 text-background-200">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 md:px-6 py-14 md:py-20 lg:grid-cols-2 lg:items-center">
        <div>
          <SectionHeading
            eyebrow="关于图鉴"
            title="把韩国妖精漫画的漂亮女主，都装进这一本图鉴"
            desc="我们是一群沉迷韩国妖精漫画角色魅力的整理爱好者。从女主的颜值与人设，到萌娘属性、CP组合与人物关系，我们希望用一本不断更新的图鉴，帮每一位同好更快找到心动的那位女主。"
          />
          <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {features.map((f) => (
              <li key={f.title} className="reveal flex gap-3 rounded-2xl bg-background-50/5 p-4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary-500/20 text-primary-300">
                  <i className={`${f.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <div>
                  <h3 className="text-sm font-semibold text-background-50">{f.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-background-300/80">{f.desc}</p>
                </div>
              </li>
            ))}
          </ul>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              了解我们
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
            <Link
              to="/faq"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50/10 px-5 py-2.5 text-sm font-medium text-background-100 transition-colors hover:bg-background-50/20"
            >
              常见问题
            </Link>
          </div>
        </div>

        <div className="reveal relative">
          <img
            src="https://readdy.ai/api/search-image?query=Collection%20of%20beautiful%20anime%20fairy%20girl%20characters%20with%20different%20hair%20colors%20and%20attributes%20arranged%20like%20a%20charming%20character%20encyclopedia%20spread%2C%20cute%20sparkles%20and%20petals%20around%20them%2C%20soft%20warm%20cream%20and%20rose%20pastel%20palette%2C%20dreamy%20romantic%20fantasy%20illustration%2C%20high%20quality&width=900&height=760&seq=about-illustration&orientation=portrait"
            alt="韩国妖精漫画女主角色图鉴整理插画"
            title="萌妖图鉴 角色整理"
            className="w-full rounded-3xl object-cover"
          />
          <div className="floaty absolute -bottom-4 -left-4 flex items-center gap-3 rounded-2xl bg-background-50 p-4 shadow-[0_12px_30px_-12px_rgba(224,94,78,0.5)]">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
              <i className="ri-team-line text-xl" aria-hidden="true"></i>
            </span>
            <div>
              <p className="font-heading text-lg font-bold text-foreground-950">10,000+</p>
              <p className="text-xs text-foreground-500">同好读者共同维护</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}